import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../Services/api';
import globals from '../../../../Globals.json';

export const saleByStoreAsync = createAsyncThunk(
  "get/sale-by-store",
  async (activedStoreId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.salesByStore + `?paginate=false&store_id=${activedStoreId}`,
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
